const ProvenanceStat = ({ label, value, total }) => (
  <div className="border border-white/10 bg-[#0f1115] p-4">
    <p className="font-serif text-2xl text-[#EBE9E1]">{value ?? "—"}<span className="text-sm text-[#8A8F98]">{total ? ` / ${total}` : ""}</span></p>
    <p className="text-[10px] tracking-widest uppercase text-[#8A8F98] mt-1">{label}</p>
  </div>
);

export const OverviewTab = ({ stats }) => {
  const p = stats?.provenance || {};
  const streamable = stats?.streamable_videos;
  return (
    <div className="space-y-8">
      <div data-testid="provenance-panel" className="border border-white/10 bg-[#121418] p-6">
        <h3 className="font-serif text-2xl text-[#EBE9E1] mb-1.5">Provenance Completeness</h3>
        <p className="text-[#8A8F98] text-sm mb-5">How much documentation work remains across the {streamable ?? "—"} viewable recordings before beta.</p>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <ProvenanceStat label="Awaiting verification" value={p.needs_verification} total={streamable} />
          <ProvenanceStat label="No rights holder" value={p.missing_rights_holder} total={streamable} />
          <ProvenanceStat label="No recording date" value={p.missing_recording_date} total={streamable} />
          <ProvenanceStat label="No location / dojo" value={p.missing_location} total={streamable} />
        </div>
        {stats?.pending_contributions > 0 && (
          <p data-testid="overview-pending-contributions" className="text-sm text-[#C08A3E] mt-5">
            {stats.pending_contributions} pending submission{stats.pending_contributions > 1 ? "s" : ""} awaiting review in the Submissions tab.
          </p>
        )}
      </div>

      <div className="border border-white/10 bg-[#121418] p-6">
        <h3 className="font-serif text-2xl text-[#EBE9E1] mb-4">Newsletter History</h3>
        {stats?.newsletter_log?.length ? stats.newsletter_log.map((l, i) => (
          <div key={l.sent_at || i} className="flex justify-between py-3 border-b border-white/5 text-sm gap-4">
            <span className="text-[#EBE9E1] min-w-0 truncate">{(l.titles || [l.title]).filter(Boolean).join(" · ")}</span>
            <span className="text-[#8A8F98] shrink-0">{l.count || 1} video{(l.count || 1) > 1 ? "s" : ""} · {l.recipients} recipients · {new Date(l.sent_at).toLocaleDateString()} · {l.delivered ? "sent" : "featured only"}</span>
          </div>
        )) : <p className="text-[#8A8F98] text-sm">No editions sent yet. "This Week from the Archive" is scheduled automatically every Tuesday & Friday.</p>}
      </div>
    </div>
  );
};
